import { render, staticRenderFns } from "./CorporateTraining.vue?vue&type=template&id=1bb56f3a&scoped=true"
import script from "./CorporateTraining.vue?vue&type=script&lang=js"
export * from "./CorporateTraining.vue?vue&type=script&lang=js"
import style0 from "./CorporateTraining.vue?vue&type=style&index=0&id=1bb56f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb56f3a",
  null
  
)

export default component.exports